// extracted by mini-css-extract-plugin
module.exports = {"error":"error--O7ftV"};
    if(module.hot) {
      // 1637785519279
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  